module.exports = __webpack_public_path__ + "media/src/assets/images/img-travel-space-e3dd92d6ce4e8c9223628f04f651bff4.png";